module.exports = __webpack_public_path__ + "static/img/TUSCANY_MAPLE.414cb45.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TUSCANY_MAPLE.jpg
// module id = hOUT
// module chunks = 0